'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.palSdkController = undefined;

var _assign = require('lodash/assign');

var _assign2 = _interopRequireDefault(_assign);

var _applicationState = require('../utils/applicationState');

var _htmlUtils = require('../utils/htmlUtils');

var _htmlUtils2 = _interopRequireDefault(_htmlUtils);

var _logger = require('../logging/logger');

var _logger2 = _interopRequireDefault(_logger);

var _constants = require('../ads/constants');

var _constants2 = require('../logging/constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var requestOptions = {
  adWillAutoPlay: true,
  adWillPlayMuted: false,
  continuousPlayback: true,
  descriptionUrl: 'https%3A%2F%2Ftunein.com',
  iconsSupported: false,
  playerType: 'web',
  playerVersion: '3.0' // IMA SDK Version
};

var palSdkController = exports.palSdkController = {
  init: function init() {
    this.handleNonceError = this.handleNonceError.bind(this);
    this.getNonce = this.getNonce.bind(this);
    this.report = this.report.bind(this);

    this.loadScript();
  },
  getNonce: function getNonce() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.scriptLoaderPromise;

            case 2:
              _context.next = 4;
              return _this.generateNonce();

            case 4:
              return _context.abrupt('return', _context.sent);

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  loadScript: function loadScript() {
    var _this2 = this;

    this.scriptLoaderPromise = new Promise(function (res) {
      _this2.resolveScriptLoaderPromise = res;
      _htmlUtils2.default.addScript(_constants.PAL_SCRIPT, false, _constants.PAL_SCRIPT_ID, _this2.initNonceLoader.bind(_this2));
    });
  },
  initNonceLoader: function initNonceLoader() {
    try {
      // eslint-disable-next-line no-undef
      this.nonceLoader = new goog.pal.NonceLoader();
    } catch (error) {
      this.handleNonceError(error, 'Error during Google PAL NonceLoader initialization.');
    }

    this.resolveScriptLoaderPromise();
  },
  generateNonce: function generateNonce() {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var nonceRequest;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              nonceRequest = _this3.generateNonceRequest();
              _context2.next = 4;
              return _this3.loadNonceManager(nonceRequest);

            case 4:
              _this3.nonceManager = _context2.sent;
              return _context2.abrupt('return', _this3.nonceManager.getNonce());

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2['catch'](0);

              _this3.handleNonceError(_context2.t0);
              return _context2.abrupt('return', '');

            case 12:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this3, [[0, 8]]);
    }))();
  },
  generateNonceRequest: function generateNonceRequest() {
    // eslint-disable-next-line no-undef
    var nonceRequest = new goog.pal.NonceRequest();
    nonceRequest.ppid = (0, _applicationState.getState)(_applicationState.State.ppid);

    return (0, _assign2.default)(nonceRequest, requestOptions);
  },
  loadNonceManager: function loadNonceManager(nonceRequest) {
    return this.nonceLoader.loadNonceManager(nonceRequest).catch(this.handleNonceError);
  },
  handleNonceError: function handleNonceError(error, message) {
    _logger2.default.debug(message || 'Error during Google PAL nonce generation.', error);
    _logger2.default.error({
      message: _constants2.PAL_NONCE_GENERATOR_ERROR,
      error: error
    });
  },
  report: function report(type) {
    try {
      this.nonceManager['sendAd' + type]();
    } catch (error) {
      this.handleReportingError(error);
    }
  },
  handleReportingError: function handleReportingError(error) {
    _logger2.default.debug('Error reporting Google PAL action.', error);
    _logger2.default.error({
      message: _constants2.PAL_REPORTING_ERROR,
      error: error
    });
  }
};

// public interface
exports.default = {
  init: function init() {
    palSdkController.init.call(palSdkController);
  },
  getNonce: function getNonce() {
    var _this4 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return palSdkController.getNonce();

            case 3:
              return _context3.abrupt('return', _context3.sent);

            case 6:
              _context3.prev = 6;
              _context3.t0 = _context3['catch'](0);
              return _context3.abrupt('return', '');

            case 9:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this4, [[0, 6]]);
    }))();
  },
  reportAdImpression: function reportAdImpression() {
    palSdkController.report('Impression');
  },
  reportAdClick: function reportAdClick() {
    palSdkController.report('Click');
  }
};